/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Not Sent

1 = Pending

2 = Approved

3 = Rejected

4 = Not Needed


 */
export type ApprovalStatus =
  (typeof ApprovalStatus)[keyof typeof ApprovalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApprovalStatus = {
  NotSent: 0,
  Pending: 1,
  Approved: 2,
  Rejected: 3,
  NotNeeded: 4,
} as const;
